import { Box, Modal, Typography } from "@mui/material";
import React, { useState } from "react";
import { ResetPassFormBox, ResetPassMainBox } from "./resetPassStyles";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useDispatch, useSelector } from "react-redux";
import {
  chooseModalLogin,
  closeChooseModal,
} from "../../../../Infrastructure/States/authModalsSlice";
import { useFormik } from "formik";
import {
  sendPasswordResetEmail,
} from "firebase/auth";
import * as Yup from "yup";
import { ShowSuccessToast } from "../../Toast/toast";
import { mainFont } from "../../../../Infrastructure/Theme/fontFamily";
import { trackEvent } from "../../../../Infrastructure/Utilities/analytics";
import AnalyticsConstants from "../../../../Infrastructure/Constants/AnalyticsContants";
import ERROR_CONSTANTS from "../../../../Infrastructure/Constants/errorConstants";
import {ShowErrorToast} from "../../Toast/toast";
import { auth, functions } from "../../../../Infrastructure/config";
import { httpsCallable } from "firebase/functions"
import { emailSchema } from "../../../../Infrastructure/Utilities/emailValidator";
import ButtonLoading from "../../Button/ButtonLoading";
import { safeClientLogEvent } from "../../../../Infrastructure/Utilities/safeClientLogEvent";
import { UNAUTH_LOGS_CLIENT } from "../../../../Infrastructure/Constants/logsConstant";
import { StyledTextField } from "../../../../Infrastructure/Theme/styledComponents";

export const ResetPassword = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const ip = useSelector((state)=>state.ip.address)
  const [emailSent, setEmailSent] = useState(false);
  const page = useSelector((state) => state.route.currentRoute);
  const isOpenModal = useSelector((state) => state.auth.isOpenModal);
  
  const handleCloseModal = () => {
    resetPassFormik.resetForm()
    dispatch(closeChooseModal());
  };
  const handleBack = () => {
    dispatch(chooseModalLogin());
    resetPassFormik.resetForm()
  };

  const handleLoginButtonClick = () => {
    dispatch(chooseModalLogin());
  };
  const validationSchemaForResetPass = Yup.object().shape({
    email: emailSchema,
  });
  const resetPassFormik = useFormik({
    initialValues: {
      email: "",
    },

    validationSchema: validationSchemaForResetPass,
    onSubmit: async (values, { setFieldError }) => {
      const { email } = values;
      try {
        setLoading(true)
        const findEmail = httpsCallable(functions, "findemail")
        const response = await findEmail({ email, page, ip });
        if(!response.data.isSuccess){
          safeClientLogEvent({
            ...UNAUTH_LOGS_CLIENT.RESET_PASSWORD_ERROR,
            source: "ResetPassword.jsx",
            error: "Reset Password Email  Sent",
            metadata: {email}
        });
          setFieldError("email", response.data.errorMessage);
          return;
        }
        await sendPasswordResetEmail(auth, email);
        setEmailSent(true);
        ShowSuccessToast("Email Sent!");
        safeClientLogEvent({
          ...UNAUTH_LOGS_CLIENT.RESET_PASSWORD_EMAIL_SENT,
          source: "ResetPassword.jsx",
          metadata: {email}
        });
        try {
          trackEvent(AnalyticsConstants.PASSWORD_RESET, { email });
        } catch (trackingError) {
          safeClientLogEvent({
            ...UNAUTH_LOGS_CLIENT.TRACKING_EVENT_FAILED,
            source: "ResetPassword.jsx",
            error: trackingError.message,
            metadata: null
        });
        }
      } catch (error) {
        ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST);
        safeClientLogEvent({
          ...UNAUTH_LOGS_CLIENT.RESET_PASSWORD_ERROR,
          source: "ResetPassword.jsx",
          error: error.message,
          metadata: null
        });
      } finally {
        setLoading(false)
      }
    },
  });
  const customStyles = {
    backdrop: {
      backgroundColor: 'transparent', // Set the backdrop background color to transparent
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }
  };

  return (
      <Modal
        disableScrollLock
        open={isOpenModal}
        onClose={handleCloseModal}
        aria-labelledby="login-modal-title"
        aria-describedby="login-modal-description"
        sx={customStyles.modal}
        BackdropProps={{
          sx: customStyles.backdrop
        }}
      >
        <ResetPassMainBox>
          <Box
            px={2}
            sx={{
              pt: 1,
              px: 3,
              width: '100%',
              display: 'flex',
              borderTopLeftRadius: '50px',
              borderTopRightRadius: '50px',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{cursor:"pointer"}}>
              <ArrowBackIcon onClick={handleBack} />
            </Box>
            <Box sx={{cursor:"pointer"}}>
              <CloseIcon onClick={handleCloseModal} />
            </Box>
          </Box>

          <Typography
            variant="h1"
            mx={2}
            my={4}
            color="primary"
            sx={{ fontSize: "30px" }}
          >
            Reset Password
          </Typography>

          <ResetPassFormBox
            component="form"
            onSubmit={resetPassFormik.handleSubmit}
            noValidate
          >
            <StyledTextField
              name="email"
              sx={{ mt: "6px" }}
              label={
                resetPassFormik.touched.email &&
                  Boolean(resetPassFormik.errors.email)
                  ? `${resetPassFormik.errors.email}`
                  : "Email"
              }
              variant="standard"
              onChange={resetPassFormik.handleChange}
              value={resetPassFormik.values.email}
              error={
                resetPassFormik.touched.email &&
                Boolean(resetPassFormik.errors.email)
              }
              fullWidth
            />
            <Box mt={6} p={2}>
              <Box>
                <ButtonLoading
                  type={'submit'}
                  loading={loading}
                  text={emailSent ? "Resend Email" : "Reset Password"}
                />
              </Box>
              {emailSent ? (
                <Typography
                  color="primary"
                  pt={4}
                  onClick={handleLoginButtonClick}
                  sx={{
                    textDecoration: "none",
                    fontSize: "22px",
                    cursor: "pointer",
                    textAlign: "center",
                    fontFamily: `${mainFont}`,
                  }}
                >
                  Login
                </Typography>
              ) : null}
            </Box>
          </ResetPassFormBox>
        </ResetPassMainBox>
      </Modal>
  );
};
